import React, { Component } from 'react';
import './Modal.scss';

export default class Modal extends Component {
  render() {
    const { handleClose, show, children } = this.props;

    return (
      <div className={show ? "modal display-block" : "modal display-none"}>
        <section className="modal-main">
          <img src={children } />
          <button onClick={handleClose}>close</button>
        </section>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js